/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Region_South_AmericaInputs */

const bn_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দক্ষিণ আমেরিকা`)
};

const de_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Südamerika`)
};

const el_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Νότια Αμερική`)
};

const en_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`South America`)
};

const es_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudamerica`)
};

const fr_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amérique du Sud`)
};

const hi_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दक्षिण अमेरिका`)
};

const hu_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dél-Amerika`)
};

const id_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amerika Selatan`)
};

const it_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sud America`)
};

const ja_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`南アメリカ`)
};

const ko_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`남아메리카`)
};

const nl_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuid-Amerika`)
};

const pl_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ameryka Południowa`)
};

const pt_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ámérica do Sul`)
};

const ru_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Южная Америка`)
};

const sv_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sydamerika`)
};

const tr_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güney Amerika`)
};

const uk_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Південна Америка`)
};

const vi_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nam Mỹ`)
};

const zh_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`南美洲`)
};

const zh_hant_region_south_america = /** @type {(inputs: Region_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`南美洲`)
};

/**
* | output |
* | --- |
* | "South America" |
*
* @param {Region_South_AmericaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const region_south_america = /** @type {((inputs?: Region_South_AmericaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Region_South_AmericaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_region_south_america(inputs)
	if (locale === "de") return de_region_south_america(inputs)
	if (locale === "el") return el_region_south_america(inputs)
	if (locale === "en") return en_region_south_america(inputs)
	if (locale === "es") return es_region_south_america(inputs)
	if (locale === "fr") return fr_region_south_america(inputs)
	if (locale === "hi") return hi_region_south_america(inputs)
	if (locale === "hu") return hu_region_south_america(inputs)
	if (locale === "id") return id_region_south_america(inputs)
	if (locale === "it") return it_region_south_america(inputs)
	if (locale === "ja") return ja_region_south_america(inputs)
	if (locale === "ko") return ko_region_south_america(inputs)
	if (locale === "nl") return nl_region_south_america(inputs)
	if (locale === "pl") return pl_region_south_america(inputs)
	if (locale === "pt") return pt_region_south_america(inputs)
	if (locale === "ru") return ru_region_south_america(inputs)
	if (locale === "sv") return sv_region_south_america(inputs)
	if (locale === "tr") return tr_region_south_america(inputs)
	if (locale === "uk") return uk_region_south_america(inputs)
	if (locale === "vi") return vi_region_south_america(inputs)
	if (locale === "zh") return zh_region_south_america(inputs)
	return zh_hant_region_south_america(inputs)
});